import { render } from "./login.vue?vue&type=template&id=707b8c58&scoped=true&ts=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=707b8c58&scoped=true&lang=scss"

import exportComponent from "E:\\sunjibo\\upstream_space\\code\\shenzhou\\medical-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707b8c58"]])

export default __exports__